{
  "logoAlt": "Smart Word Labs",
  "footer": {
    "copyright": "© {{year}} Smart Word Labs · {{tagline}}"
  },
  "breadcrumb": {
    "home": "Accueil",
    "ariaLabel": "Fil d'Ariane"
  },
  "notifications": {
    "ariaLabel": "Notifications",
    "unreadMore": "9+",
    "title": "Alertes",
    "markRead": "Marquer comme lu",
    "new": "nouveau",
    "empty": "Aucune alerte pour le moment.",
    "error": "Impossible de mettre à jour les notifications"
  },
  "mobileCta": {
    "bookFreeAssessment": "Réserver une évaluation gratuite"
  }
}
